<template>
  <div>
    <!-- profile -->
    <div class="card mb-g rounded-top ">
      <div class="row no-gutters row-grid">
        <check-permission permissions="USER.SET_PASSWORD" :entityType="entityType" :entityId="profile.id">
          <button
            class="btn btn-sm btn-smart-dark-outline rounded-pill mt-2 mr-2 absolute-right"
            @click="openModal('passwordChange')"
          >
            <i class="mdi mdi-account" aria-hidden="true"/> &nbsp;{{ $t('buttons.change-password') }}
          </button>
        </check-permission>

        <div class="col-12">
          <div class="d-flex flex-column align-items-center justify-content-center p-4">
            <img
              width="250"
              height="300"
              class="rounded-circle shadow-2 img-thumbnail"
              alt="Awatar użytkownika"
              :src="avatarSrc"
            />

            <h5 class="mb-0 fw-700 text-center mt-3">{{ profile.firstName }} {{ profile.lastName }}</h5>
          </div>
        </div>

        <detail-item class="col-md-6 " label="text.profile.email">
          {{ profile.email || $t('text.profile.na') }}
        </detail-item>

        <detail-item class="col-md-6 " label="text.profile.phoneNumber">
          {{ profile.phoneNumber || $t('text.profile.na') }}
        </detail-item>

        <detail-item class="col-md-6 " label="text.profile.birthDate">
          {{ profile.birthDate || $t('text.profile.na') }}
        </detail-item>

        <detail-item class="col-md-6 " label="text.profile.education">
          {{ profile.education || $t('text.profile.na') }}
        </detail-item>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <div class="card mb-2">
          <div class="card-header py-2">
            <div class="card-title">
              <strong>{{ $t('text.profile.jobHistory') }}</strong>
            </div>
          </div>

          <div class="card-body">{{ profile.jobHistory || $t('text.profile.na') }}</div>
        </div>
      </div>

      <div class="col-6">
        <div class="card mb-2">
          <div class="card-header py-2">
            <div class="card-title">
              <strong>{{ $t('text.profile.achievements') }}</strong>
            </div>
          </div>

          <div class="card-body">
            {{ profile.achievements || $t('text.profile.na') }}
          </div>
        </div>
      </div>
    </div>

    <password-change-modal :show="modals.passwordChange" @close="closeModal('passwordChange')" />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import DetailItem from '@/components/details/DetailItem';
import PasswordChangeModal from '@/components/modals/PasswordChangeModal';
import { displayModalMixin } from '@/mixins/displayModal';
import { gravatarUrl } from '@/utils/media';
import { TableName } from '../../enums/tableName.enum';

export default {
  components: {
    DetailItem,
    PasswordChangeModal
  },

  mixins: [displayModalMixin],
  computed: {
    ...mapState({
      profile: state => state.profile.data,
      avatarSrc: state => gravatarUrl(state.profile.data.email)
    })
  },
  data() {
    return { entityType: TableName.Profile };
  }
};
</script>

<style>
.absolute-right {
  position: absolute;
  right: 0;
  z-index: 1;
}
</style>
